import { c as _c } from "react/compiler-runtime";
import { ListItem, ListItemIcon, Tooltip } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { makeStyles } from '@mui/styles';
import { useIsOverflowed } from '../../../utils';
import SelectableItemLabel from './SelectableItemLabel';
const useStyles = makeStyles(({
  palette,
  spacing
}) => ({
  root: {
    color: 'inherit',
    width: '100%',
    padding: spacing(1),
    borderRadius: 4,
    overflow: 'auto',
    pointerEvents: 'auto',
    '& + $root': {
      marginTop: spacing(1)
    },
    '&:hover': {
      backgroundColor: palette.menu.background.unselected.hover,
      color: palette.text.onMain
    },
    '&.Mui-selected': {
      backgroundColor: palette.menu.background.selected.enabled
    },
    '&.Mui-selected:hover': {
      backgroundColor: palette.menu.background.selected.hover
    }
  },
  leftIcon: {
    minWidth: 'auto',
    marginRight: spacing(2),
    color: 'inherit'
  }
}), {
  classNamePrefix: 'SelectableItem'
});
export default function SelectableItem(t0) {
  const $ = _c(31);
  let label;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      label,
      isSelected: t1,
      component: t2,
      leftIcon: t3,
      variant: t4,
      labelAdornment: t5,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    label = $[1];
    otherProps = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  const isSelected = t1 === undefined ? false : t1;
  const component = t2 === undefined ? "li" : t2;
  const leftIcon = t3 === undefined ? null : t3;
  const variant = t4 === undefined ? "bodySmall" : t4;
  const labelAdornment = t5 === undefined ? null : t5;
  const classes = useStyles();
  let t6;
  if ($[8] !== isSelected || $[9] !== label) {
    t6 = [label, isSelected];
    $[8] = isSelected;
    $[9] = label;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const {
    isOverflowed,
    setDomElement
  } = useIsOverflowed(t6);
  const isClickable = Boolean(otherProps.onClick);
  const ListComponent = isClickable ? ListItemButton : ListItem;
  const t7 = isOverflowed ? label : "";
  let t8;
  if ($[11] !== classes.leftIcon || $[12] !== leftIcon) {
    t8 = leftIcon && <ListItemIcon data-testid="left-icon" className={classes.leftIcon}>{leftIcon}</ListItemIcon>;
    $[11] = classes.leftIcon;
    $[12] = leftIcon;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== label || $[15] !== setDomElement || $[16] !== variant) {
    t9 = <SelectableItemLabel variant={variant} ref={setDomElement} color="inherit">{label}</SelectableItemLabel>;
    $[14] = label;
    $[15] = setDomElement;
    $[16] = variant;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== ListComponent || $[19] !== classes.root || $[20] !== component || $[21] !== isSelected || $[22] !== labelAdornment || $[23] !== otherProps || $[24] !== t8 || $[25] !== t9) {
    t10 = <ListComponent className={classes.root} disableGutters={true} component={component} selected={isSelected} {...otherProps}>{t8}{t9}{labelAdornment}</ListComponent>;
    $[18] = ListComponent;
    $[19] = classes.root;
    $[20] = component;
    $[21] = isSelected;
    $[22] = labelAdornment;
    $[23] = otherProps;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== label || $[28] !== t10 || $[29] !== t7) {
    t11 = <Tooltip key={label} title={t7} enterDelay={500}>{t10}</Tooltip>;
    $[27] = label;
    $[28] = t10;
    $[29] = t7;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}